/* global window */
// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import qs from 'qs';
import { components, elements } from '@peachjar/components';
import styles from './SetupStaffPasswordContainer.css';
import PasswordRequirements from '../components/PasswordRequirements';
import { passesAllRequirements } from '../utils/index';
import WomanTypingSvg from '../components/WomanTyping.svg';
import {
  setStaffPassword,
  setQueryStringParams,
  checkPasswordPreviouslySet,
  setNewPassword,
} from '../setup-staff-password.duck';

const {
  FullSpread,
  ContentColumn,
  WhitespaceColumn,
  Buttons: { ButtonPrimaryLarge },
  TextInput,
} = components;

const { Quote, EyeIcon } = elements;

const QUOTE =
  'Peachjar has been a godsend. We now know that flyers get to our parents electronically without taking any class instruction time away from teachers.';
const AUTHOR = 'Daniel Voelpel';
const AUTHOR_TITLE =
  'Public Information Director for Tacoma Public Schools, Washington';

type ReduxDispatchProps = {|
  +handlePasswordInputChange: (event: any) => void,
  +handleSetPasswordSubmit: () => void,
  +handleSetQueryStringParams: (params: any) => void,
  +handleCheckPassword: () => void,
|};

type ReduxStateProps = {|
  staffPassword: string,
  queryStringParams: any,
  passwordCheckPerformed: boolean,
  passwordPreviouslySet: boolean,
|};

type LocalProps = {|
  location: any,
|};

type State = {|
  isPasswordVisible: boolean,
  isPasswordFieldFocused: boolean,
|};

type Props = {|
  ...ReduxDispatchProps,
  ...ReduxStateProps,
  ...LocalProps,
|};

class SetupStaffPasswordContainer extends Component<Props, State> {
  state = {
    isPasswordVisible: false,
    isPasswordFieldFocused: false,
  };

  componentDidMount() {
    const { handleSetQueryStringParams, location } = this.props;

    if (location.search) {
      const params = qs.parse(location.search, { ignoreQueryPrefix: true });
      handleSetQueryStringParams(params);
    }
  }

  togglePasswordVisibility = () => {
    const { isPasswordVisible } = this.state;
    this.setState({ isPasswordVisible: !isPasswordVisible });
  };

  togglePasswordFieldFocus = () => {
    const { isPasswordFieldFocused } = this.state;
    this.setState({ isPasswordFieldFocused: !isPasswordFieldFocused });
  };

  render() {
    const { isPasswordVisible, isPasswordFieldFocused } = this.state;
    const {
      staffPassword,
      queryStringParams,
      passwordCheckPerformed,
      handlePasswordInputChange,
      handleSetPasswordSubmit,
      handleCheckPassword,
      passwordPreviouslySet,
    } = this.props;

    const isSubmitEnabled = passesAllRequirements(staffPassword);

    if ('redirectUrl' in queryStringParams && passwordPreviouslySet) {
      window.location = queryStringParams.redirectUrl;
      return <noscript />;
    }

    if ('token' in queryStringParams && !passwordCheckPerformed) {
      handleCheckPassword();
    }

    return (
      <div>
        {!passwordPreviouslySet && (
          <div>
            <div className="container-fluid m-0 p-0">
              <FullSpread>
                <ContentColumn leftAction className="col-lg-6">
                  <div className={styles.wrapper}>
                    <h1 className={styles.header}>Set your password.</h1>
                    <p className={styles.text}>
                      Enter your new password to set it.
                    </p>
                    <TextInput
                      id="password"
                      className={styles.input}
                      name="password"
                      label="Password"
                      type={isPasswordVisible ? 'text' : 'password'}
                      onChange={handlePasswordInputChange}
                      onFocus={this.togglePasswordFieldFocus}
                      onBlur={this.togglePasswordFieldFocus}
                      value={staffPassword}
                      endAdornment={
                        <EyeIcon
                          isPasswordVisible={isPasswordVisible}
                          togglePasswordVisibility={
                            this.togglePasswordVisibility
                          }
                        />
                      }
                    />
                    <div style={{ position: 'absolute', marginBottom: '1rem' }}>
                      <PasswordRequirements
                        isPasswordFieldFocused={isPasswordFieldFocused}
                        pw={staffPassword}
                      />
                      <div className={styles.buttonWrapper}>
                        <ButtonPrimaryLarge
                          id="btnSubmit"
                          data-testid="click-submit-set-password"
                          disabled={!isSubmitEnabled}
                          onClick={handleSetPasswordSubmit}
                        >
                          Submit
                        </ButtonPrimaryLarge>
                      </div>
                    </div>
                  </div>
                </ContentColumn>
                <WhitespaceColumn className="d-none d-lg-flex">
                  <WomanTypingSvg className={styles.svg} />
                  <Quote
                    content={QUOTE}
                    author={AUTHOR}
                    authorTitle={AUTHOR_TITLE}
                  />
                </WhitespaceColumn>
              </FullSpread>
            </div>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state): ReduxStateProps => ({
  staffPassword: state.setupStaffPassword.password,
  queryStringParams: state.setupStaffPassword.queryStringParams,
  passwordCheckPerformed: state.setupStaffPassword.passwordCheckPerformed,
  passwordPreviouslySet: state.setupStaffPassword.passwordPreviouslySet,
});

const mapDispatchToProps = (dispatch): ReduxDispatchProps => ({
  handlePasswordInputChange: event => {
    dispatch(setStaffPassword(event.target.value));
  },
  handleSetQueryStringParams: params => {
    dispatch(setQueryStringParams(params));
  },
  handleSetPasswordSubmit: () => {
    dispatch(setNewPassword());
  },
  handleCheckPassword: () => {
    dispatch(checkPasswordPreviouslySet());
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SetupStaffPasswordContainer);



// WEBPACK FOOTER //
// ./src/Onboarding/Setup/staff-password/containers/SetupStaffPasswordContainer.jsx